// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b1j0L8iSBKTx2zd8wojH {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
  background-color: #a5a5;
  height: 100vh;
  width: 200px;
  padding: 10px 20px;
  padding-top: 60px;
}

.u70GKlhv7HwCgT4kdveA {
  display: none;
}

.QcL6IyWEW0jESrlJiTPy {
  font-weight: bold;
  margin: 15px 0;
}

.aqVHXnJQb7e_hvMNn9Aj {
  max-width: 100%;
  border-radius: 15px;
  padding: 5px 10px;
  border: none;
  outline: none;
}

.JDuHXkkGmg5GExJ6T4Bg {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 15px;
}

.JDuHXkkGmg5GExJ6T4Bg button {
  font-size: medium;
}
`, "",{"version":3,"sources":["webpack://./src/Views/DebugConsole/index.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".debugConsole {\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 5;\n  background-color: #a5a5;\n  height: 100vh;\n  width: 200px;\n  padding: 10px 20px;\n  padding-top: 60px;\n}\n\n.hide {\n  display: none;\n}\n\n.FPSContainer {\n  font-weight: bold;\n  margin: 15px 0;\n}\n\n.countInput {\n  max-width: 100%;\n  border-radius: 15px;\n  padding: 5px 10px;\n  border: none;\n  outline: none;\n}\n\n.buttonContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin-top: 15px;\n}\n\n.buttonContainer button {\n  font-size: medium;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debugConsole": `b1j0L8iSBKTx2zd8wojH`,
	"hide": `u70GKlhv7HwCgT4kdveA`,
	"FPSContainer": `QcL6IyWEW0jESrlJiTPy`,
	"countInput": `aqVHXnJQb7e_hvMNn9Aj`,
	"buttonContainer": `JDuHXkkGmg5GExJ6T4Bg`
};
export default ___CSS_LOADER_EXPORT___;
